import { render, staticRenderFns } from "./UserProfileLite.vue?vue&type=template&id=5b4b1254"
import script from "./UserProfileLite.vue?vue&type=script&lang=js"
export * from "./UserProfileLite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports